class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {


   $('.progress_steps span#step1').attr("data-shipping" , step1);
     $('.progress_steps span#step2').attr("data-gift" , step2);
     $('.progress_steps span#step3').attr("data-discount" , step3);
     $('.progress_steps span#step4').attr("data-surprise" , step4);

  var step1 = Number( $('.progress_steps span#step1').attr('data-shipping') ) ;
  var step2 = Number( $('.progress_steps span#step2').attr('data-gift') ) ;
  var step3 = Number( $('.progress_steps span#step3').attr('data-discount') ) ;
  var step4 = Number( $('.progress_steps span#step4').attr('data-surprise') ) ;



      
var getprice = '';  
         var data_price = '';

         if($(document).find('.subtotal').length){
             getprice = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total"));  
             data_price = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total"));  
         }else{
             getprice = Number($(document).find('.free-shipping__text').attr("data-price"));   
             data_price = Number($(document).find('.free-shipping__text').attr("data-price"));  
         }
         if(getprice <= step1){ 
           var step1getPrice = step1 - getprice;  
            let step1getPriceCurr = formPrice(
                          step1getPrice * 100,
                          window.itgShopInfo.shop.money_with_currency_format
                        ); 
           $('.free-shipping__text .changeText').html('<strong class="priceValue"  data-step="step1">'+step1getPriceCurr+'</strong>  Gets free shipping added automatically').fadeIn();
       $('.mini-cart__inner span.free-shipping__text.customShip').removeClass('SwymGrTransition');
         }else if(getprice <= step2){
           var step2getPrice = step2 - getprice;  
           let step2getPriceCurr = formPrice(
                          step2getPrice * 100,
                          window.itgShopInfo.shop.money_with_currency_format
                        );
           $('.free-shipping__text .changeText').html('<strong class="priceValue" data-step="step2">'+step2getPriceCurr+'</strong> to unlock your next <strong>Surprise !</strong>');
       $('.mini-cart__inner span.free-shipping__text.customShip ').removeClass('SwymGrTransition');
         }else if(getprice <= step3){
           var step3getPrice = step3 - getprice;    
           let step3getPriceCurr = formPrice(
                          step3getPrice * 100,
                          window.itgShopInfo.shop.money_with_currency_format
                        );
           $('.free-shipping__text .changeText').html('<strong class="priceValue" data-step="step2">'+step3getPriceCurr+'</strong> to unlock your next <strong>Surprise !</strong>');
       $('.mini-cart__inner span.free-shipping__text.customShip ').removeClass('SwymGrTransition');
         }else if(getprice <= step4){     
           var step4getPrice = step4 - getprice;    
           let step4getPriceCurr = formPrice(
                          step4getPrice * 100,
                          window.itgShopInfo.shop.money_with_currency_format
                        );
           $('.free-shipping__text .changeText').html('<strong class="priceValue"  data-step="step4">'+step4getPriceCurr+'</strong> to unlock your next <strong>Surprise !</strong>');
       $('.mini-cart__inner span.free-shipping__text.customShip ').removeClass('SwymGrTransition');
         }else{ 
           $('.free-shipping__text .changeText').html('<span data-step="step4">congratulations_html</span>');
       $('.mini-cart__inner span.free-shipping__text.customShip ').removeClass('SwymGrTransition');
         }

          var NewPriceGet = parseInt(data_price * 100) / parseInt(step4);
           console.log('test' + data_price)
          if (NewPriceGet > 100) {
             NewPriceGet = 100 + '%';
          } else {
            NewPriceGet = NewPriceGet + '%';
          }
         $('.free-shipping__progress').css('--progress' ,  NewPriceGet);




      
      return;
    }
    
    const summaryElement = this.drawer.querySelector('summary');
    summaryElement.click();

    setTimeout(() => {
      setHeaderHeight();
    }, 250);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.header) this.header.reveal();
      this.open();
     setTimeout(function(){
      $('body').removeClass('barDisconnect');
    },2000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);



